import { ICDFWPublicLandsAdvisoryProperties } from '@autopylot-internal/tiles-client';
import { SecondaryWarningAdvisory } from '../SecondaryAdvisory';
import { AdvisoryBlockIcon } from '../../components/icons/Icons';
import { ICompositeAdvisoryProperties } from './ICompositeAdvisoryProperties';
import { AdvisoryLink } from './AdvisoryLink';

export const CDFWPublicLandsAdvisory = (props: (ICompositeAdvisoryProperties<ICDFWPublicLandsAdvisoryProperties>)) => {
    const distinctNames = Array.from(new Set(props.advisories.map(a => a.PROP_NAME)));
    return (
        <SecondaryWarningAdvisory header="California Fish and Wildlife" advisoryType={props.advisoryType} GLOBAL_ID={props.advisories[0].GLOBAL_ID} icon={AdvisoryBlockIcon} iconColor='danger'>
            <>
                <p>
                    Your mission overlaps <strong>{distinctNames.join(', ')}</strong>. All drone operations are prohibited
                    in California Department of Fish and Wildlife lands except as authorized by a special use permit
                    issued by the department.
                </p>
                <p>
                    <AdvisoryLink
                        text="Legal and Responsible Drone Operations"
                        url="https://wildlife.ca.gov/drones#regulations"
                    />
                </p>
            </>
        </SecondaryWarningAdvisory>
    );
};
